import { FreeMode, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useParams } from "react-router-dom";

import { ROUTES } from "@/config/routes";
import { useGetContentEpisodesSus } from "@/hooks/api/content.hooks";
import { useGetEpisodeHistory } from "@/hooks/api/feed.hooks";
import { isMobile } from "@/utils/constatns";

import EpisodeCard from "../cards/EpisodeCard";
import { IconArrowLeft } from "../icons";

interface EpisodeSliders {
  currentSeason: number;
  contentId: number;
}

const DetailEpisodesSlides = ({ currentSeason, contentId }: EpisodeSliders) => {
  const { id } = useParams();
  const { data: episodes } = useGetContentEpisodesSus(currentSeason);
  const token = localStorage.getItem("splay:token");

  if (!episodes) return <></>;

  const { data: history } = token ? useGetEpisodeHistory(contentId) : { data: { episodes: [] } };

  const getEpisodeHistory = (episodeId: number) => {
    return history?.episodes.find((item) => item.episode_id == episodeId);
  };

  return (
    <div className={"group/section relative mt-6 max-xl:mt-4"}>
      <Swiper
        slidesPerView={2.2}
        slidesPerGroup={1}
        spaceBetween={8}
        freeMode={{
          enabled: true,
          momentumBounceRatio: 0.1,
          momentumVelocityRatio: 0.3,
          momentumBounce: false,
        }}
        breakpoints={{
          "640": { slidesPerView: 3.2, slidesPerGroup: 3 },
          "1024": { slidesPerView: 4.4, slidesPerGroup: 4 },
          "1280": { slidesPerView: 5.5, spaceBetween: 16, slidesPerGroup: 5 },
          "1440": { slidesPerView: 5.6, spaceBetween: 16, slidesPerGroup: 5 },
        }}
        modules={[Navigation, FreeMode]}
        navigation={{
          prevEl: `.js-episodes-section-prev`,
          nextEl: `.js-episodes-section-next`,
        }}
        followFinger={isMobile}
        mousewheel={{
          forceToAxis: true,
        }}
        speed={500}
        className={"-mx-8 overflow-visible px-8"}
      >
        {episodes.episodes.map((episode) => (
          <SwiperSlide key={episode.id}>
            <EpisodeCard
              episode={episode.episode_numb}
              duration={episode.duration}
              image={episode.picture.resized}
              viewed={getEpisodeHistory(episode.id)?.time_code}
              link={ROUTES.DETAIL.SERIAL_EPISODE.replace(":id", String(id)).replace(":episodeId", String(episode.id))}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={"absolute left-3 top-0 z-[1] flex h-full flex-col items-center justify-center"}>
        <button
          type={"button"}
          title={"Предыдущий"}
          style={{ background: "linear-gradient(270deg, rgba(0, 0, 0, 0.00) 7.17%, var(--surface) 97.86%)" }}
          className={`js-episodes-section-prev group invisible absolute -left-12 flex h-full w-20 items-center justify-center bg-on-primary opacity-0 transition-all hover:bg-orange-1 disabled:!invisible disabled:!opacity-0 group-hover/section:visible group-hover/section:opacity-100 max-lg:hidden`}
        >
          <IconArrowLeft name={"arrow-left"} className={"size-10 stroke-on-primary"} />
        </button>
      </div>
      <div className={"absolute right-3 top-0 z-[1] flex h-full flex-col items-center justify-center"}>
        <button
          type={"button"}
          title={"Предыдущий"}
          style={{ background: "linear-gradient(90deg, rgba(0, 0, 0, 0.00) 7.17%, var(--surface) 97.86%)" }}
          className={`js-episodes-section-next group invisible absolute -right-12 flex h-full w-20 items-center justify-center opacity-0 transition-all hover:bg-orange-1 disabled:!invisible disabled:!opacity-0 group-hover/section:visible group-hover/section:opacity-100 max-lg:hidden`}
        >
          <IconArrowLeft name={"arrow-left"} className={"size-10 rotate-180 stroke-on-primary"} />
        </button>
      </div>
    </div>
  );
};

export default DetailEpisodesSlides;
